import { type PageEntity, apiClient, type PartnerEntity } from '@/libs/api'
import { type PartnersListRequestQuery } from '@/libs/api/types'

export type FetchPartnersQuery = {
  tenantKey: string
  query?: PartnersListRequestQuery
  dcId?: number
}

export type FetchPartnersResponse = {
  data: PartnerEntity[]
  pagination: PageEntity | null
}

export const fetchPartners = async (
  { tenantKey, dcId }: FetchPartnersQuery,
  signal?: AbortSignal
): Promise<FetchPartnersResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .partners.$get({
      query: {
        ...(dcId && { dcId }),
        enable: true
      },
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
